import Axios from "axios";
import { SET_INCREMENT_LIST, UNSET_INCREMENT_LIST } from "@/store/mutation-types";
import {
    getIncrementList,
    getIncrementById,
    getIncrementsByEmployee,
    saveUpdateIncrement,
    updateIncrement,
    deleteIncrement,
    approveIncrement,
    rejectIncrement,
    getIncrementStatistics,
    generateIncrementReferenceNumber,
} from "@/store/api";

// initial state
const state = {
    getHrmIncrementList: [],
    editingIncrement: null,
}

const getters = {
    getHrmIncrementList(state){
        return state.getHrmIncrementList;
    },
    getEditingIncrement: (state) => { 
        return state.editingIncrement;
    },
}

const mutations = {
    [SET_INCREMENT_LIST](state, data) {
        state.getHrmIncrementList = data;
    },
    [UNSET_INCREMENT_LIST](state) {
        state.getHrmIncrementList = [];
    },
    setEditingIncrement(state, increment) {
        state.editingIncrement = increment;
    },
    clearEditingIncrement(state) {
        state.editingIncrement = null;
    }
}

const actions = {
    getIncrementList({ commit }, params = {}) {
        return new Promise((resolve, reject) => {
            Axios.get(getIncrementList, { params })
                .then((response) => {
                    commit(SET_INCREMENT_LIST, response.data.data || []);
                    resolve(response.data);
                })
                .catch((error) => {
                    commit(UNSET_INCREMENT_LIST);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING", null, { root: true });
                });
        });
    },

    getIncrementById({ commit }, id) {
        return new Promise((resolve, reject) => {
            commit("SET_LOADING", { color: "primary" });
            Axios.get(getIncrementById(id))
                .then((response) => {
                    resolve(response.data);
                    commit("UNSET_LOADING");
                })
                .catch((error) => {
                    reject(error);
                    commit("UNSET_LOADING");
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },

    saveOrUpdateIncrement({ commit }, incrementData) {
        return new Promise((resolve, reject) => {
            commit("SET_LOADING", { color: "primary" });
            Axios.post(saveUpdateIncrement, incrementData)
                .then((response) => {
                    resolve(response.data);
                    commit("UNSET_LOADING");
                })
                .catch((error) => {
                    reject(error);
                    commit("UNSET_LOADING");
                })
                .finally(() => {
                    commit("UNSET_LOADING", null, { root: true });
                });
        });
    },

    updateIncrement({ commit }, { id, incrementData }) {
        return new Promise((resolve, reject) => {
            Axios.put(updateIncrement(id), incrementData)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING", null, { root: true });
                });
        });
    },

    generateIncrementReferenceNumber({ commit }) {
        return new Promise((resolve, reject) => {
            Axios.get(generateIncrementReferenceNumber)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING", null, { root: true });
                });
        });
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}
